import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { fetchBlog } from "@/lib/api";
import { Reveal, Overline } from "@/components/site/primitives";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchBlog().then(setPosts).finally(() => setLoading(false));
  }, []);

  return (
    <main className="relative min-h-screen bg-ink-0 pt-32" data-testid="blog-list">
      <div className="absolute inset-0 bg-grid opacity-20" />
      <div className="relative mx-auto max-w-7xl px-5 pb-28 lg:px-8">
        <Overline>Insights</Overline>
        <h1 className="mt-5 font-display text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
          EDUCATION GROWTH <span className="text-gradient">INSIGHTS.</span>
        </h1>
        <p className="mt-4 max-w-2xl text-base text-white/55 md:text-lg">
          Perspectives on marketing, technology, admissions and student acquisition for MBA &amp; PGDM institutions.
        </p>

        {loading ? (
          <p className="mt-16 font-mono text-sm text-white/40">Loading insights...</p>
        ) : (
          <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 3) * 0.08}>
                <Link to={`/insights/${p.slug}`} className="group block h-full">
                  <motion.article whileHover={{ y: -6 }} className="flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-ink-1 transition-colors duration-300 hover:border-brand-cyan/40" data-testid="blog-card">
                    <div className="relative h-48 overflow-hidden">
                      <img src={p.cover} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      <div className="absolute inset-0 bg-gradient-to-t from-ink-1 to-transparent" />
                      <span className="absolute left-4 top-4 rounded-full border border-white/15 bg-ink-0/70 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-brand-cyan backdrop-blur-md">{p.category}</span>
                    </div>
                    <div className="flex flex-1 flex-col p-6">
                      <h2 className="font-display text-xl font-semibold leading-snug text-white">{p.title}</h2>
                      <p className="mt-3 flex-1 text-sm leading-relaxed text-white/50">{p.excerpt}</p>
                      <div className="mt-5 flex items-center justify-between">
                        <span className="flex items-center gap-1.5 font-mono text-[11px] text-white/40"><Clock className="h-3.5 w-3.5" />{p.read_time}</span>
                        <span className="flex items-center gap-1 text-sm font-medium text-white transition-colors group-hover:text-brand-cyan">Read <ArrowRight className="h-4 w-4" /></span>
                      </div>
                    </div>
                  </motion.article>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
